import { ComponentProps } from "react";

import { twMerge } from "tailwind-merge";

export const Table = ({ className, ...props }: ComponentProps<"div">) => {
  return (
    <div
      {...props}
      className={twMerge(
        "grid grid-cols-[16px_minmax(220px,1fr)_minmax(110px,1fr)_minmax(100px,1fr)_minmax(80px,1fr)_minmax(100px,1fr)]",
        "text-riverBed text-xs font-medium",
        className
      )}
    />
  );
};
